/* DecorMama theme — global behaviors: drawers, mobile nav, reveal-on-scroll, AJAX cart. */
(function () {
  "use strict";

  var overlay = document.getElementById("overlay");

  function closeAllDrawers() {
    document.querySelectorAll(".drawer.open").forEach(function (el) {
      el.classList.remove("open");
      el.setAttribute("aria-hidden", "true");
    });
    document.querySelectorAll(".mobile-nav.open").forEach(function (el) {
      el.classList.remove("open");
    });
    if (overlay) overlay.classList.remove("open");
    document.body.classList.remove("drawer-open");
  }

  function openDrawer(name) {
    closeAllDrawers();
    var el = document.getElementById(name + "-drawer");
    if (!el) return;
    el.classList.add("open");
    el.setAttribute("aria-hidden", "false");
    if (overlay) overlay.classList.add("open");
    document.body.classList.add("drawer-open");
    var focusable = el.querySelector("input, button, a");
    if (focusable) focusable.focus();
  }

  window.DecorMama = window.DecorMama || {};
  window.DecorMama.openDrawer = openDrawer;
  window.DecorMama.closeAllDrawers = closeAllDrawers;

  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-open-drawer]");
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute("data-open-drawer"));
      return;
    }
    if (e.target.closest("[data-close-drawer]")) {
      e.preventDefault();
      closeAllDrawers();
      return;
    }
    if (e.target === overlay) {
      closeAllDrawers();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeAllDrawers();
  });

  /* Mobile nav toggle */
  document.addEventListener("click", function (e) {
    var navToggle = e.target.closest("[data-mobile-nav-toggle]");
    if (navToggle) {
      e.preventDefault();
      var nav = document.getElementById("mobile-nav");
      if (!nav) return;
      var isOpen = nav.classList.toggle("open");
      if (overlay) overlay.classList.toggle("open", isOpen);
      document.body.classList.toggle("drawer-open", isOpen);
      return;
    }
    var subToggle = e.target.closest("[data-mobile-submenu-toggle]");
    if (subToggle) {
      e.preventDefault();
      var submenu = document.getElementById(subToggle.getAttribute("aria-controls"));
      if (submenu) {
        var open = submenu.classList.toggle("open");
        subToggle.setAttribute("aria-expanded", open ? "true" : "false");
      }
    }
  });

  /* ---------------- Desktop mega menu ----------------
     One dropdown is open at a time: hovering a new top-level item takes over
     immediately instead of stacking, and leaving the nav closes on a short
     grace delay so the panel doesn't vanish while the pointer travels to it. */
  var MEGA_CLOSE_DELAY = 550;
  var openNavItem = null;
  var megaCloseTimer = null;

  function setNavItemState(item, open) {
    item.classList.toggle("is-open", open);
    var trigger = item.querySelector(".nav-item__trigger");
    if (trigger) trigger.setAttribute("aria-expanded", open ? "true" : "false");
  }

  function cancelMegaClose() {
    if (megaCloseTimer) {
      clearTimeout(megaCloseTimer);
      megaCloseTimer = null;
    }
  }

  function closeMega() {
    cancelMegaClose();
    if (openNavItem) {
      setNavItemState(openNavItem, false);
      openNavItem = null;
    }
  }

  function openMega(item) {
    cancelMegaClose();
    if (openNavItem === item) return;
    if (openNavItem) setNavItemState(openNavItem, false);
    openNavItem = item;
    setNavItemState(item, true);
  }

  function scheduleMegaClose() {
    cancelMegaClose();
    megaCloseTimer = setTimeout(closeMega, MEGA_CLOSE_DELAY);
  }

  document.body.classList.add("has-js-nav");

  document.addEventListener("pointerover", function (e) {
    if (e.pointerType === "touch" || !e.target.closest) return;
    if (!e.target.closest(".header-nav")) return;
    var item = e.target.closest(".nav-item");
    if (item) {
      openMega(item);
    } else if (e.target.closest(".top-link")) {
      /* A childless top-level link takes over too — nothing stays open behind it. */
      closeMega();
    }
    /* Bare gaps between items are ignored, so crossing them keeps the panel up. */
  });

  document.addEventListener("pointerout", function (e) {
    if (!openNavItem || e.pointerType === "touch") return;
    var to = e.relatedTarget;
    if (to && to.nodeType === 1 && openNavItem.contains(to)) return;
    scheduleMegaClose();
  });

  document.addEventListener("focusin", function (e) {
    if (!e.target.closest) return;
    var item = e.target.closest(".nav-item");
    if (item) {
      openMega(item);
    } else if (openNavItem) {
      closeMega();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeMega();
  });

  /* Reveal on scroll */
  var revealTargets = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && revealTargets.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealTargets.forEach(function (el) { io.observe(el); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add("in"); });
  }

  /* ---------------- AJAX Cart ---------------- */
  var cartState = { item_count: 0 };

  function formatMoney(cents) {
    var format = window.themeMoneyFormat || "R {{amount}}";
    var value = (cents / 100).toFixed(2);
    var parts = value.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return format.replace("{{amount}}", parts.join("."));
  }
  window.DecorMama.formatMoney = formatMoney;

  function refreshCartSections() {
    var ids = ["cart-drawer"];
    return fetch("/?sections=" + ids.join(","))
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        Object.keys(sections).forEach(function (id) {
          var target = document.getElementById("shopify-section-" + id);
          if (!target) return;
          var tmp = document.createElement("div");
          tmp.innerHTML = sections[id];
          var newContent = tmp.querySelector("[data-section-content]");
          var current = target.querySelector("[data-section-content]");
          if (newContent && current) {
            current.replaceWith(newContent);
          }
        });
        document.dispatchEvent(new CustomEvent("cart:refreshed"));
      });
  }
  window.DecorMama.refreshCartSections = refreshCartSections;

  function updateCartCount() {
    fetch("/cart.js")
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        cartState = cart;
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
      });
  }
  window.DecorMama.updateCartCount = updateCartCount;

  function addToCart(formData) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData,
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    });
  }
  window.DecorMama.addToCart = addToCart;

  document.addEventListener("submit", function (e) {
    var form = e.target.closest('form[data-add-to-cart-form], form[action$="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var submitBtn = form.querySelector("[type=submit]");
    if (submitBtn) submitBtn.setAttribute("disabled", "disabled");
    var formData = new FormData(form);
    addToCart(formData)
      .then(function () {
        return Promise.all([refreshCartSections(), updateCartCount()]);
      })
      .then(function () {
        openDrawer("cart");
      })
      .catch(function (err) {
        console.error("Add to cart failed", err);
      })
      .finally(function () {
        if (submitBtn) submitBtn.removeAttribute("disabled");
      });
  });

  document.addEventListener("click", function (e) {
    var changeBtn = e.target.closest("[data-cart-change]");
    if (!changeBtn) return;
    e.preventDefault();
    var key = changeBtn.getAttribute("data-cart-change");
    var quantity = parseInt(changeBtn.getAttribute("data-quantity"), 10);
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function () { return Promise.all([refreshCartSections(), updateCartCount()]); })
      .catch(function (err) { console.error("Cart update failed", err); });
  });

  document.addEventListener("DOMContentLoaded", updateCartCount);
})();